// Machine-assisted English-source-aligned drafts for the three additional Midwife family variants.
// These are NOT professionally reviewed, clinically signed off, or Trust approved.
// Every locale must pass contextual/native-speaker QA before a controlled patient release.
// Array fields: [title, patient summary, difference from the registered Midwife parent].
export const EXTENDED_MIDWIFE_FAMILY_DRAFTS = {
  "fr": {
    "community_midwife": [
      "Sage-femme de proximité",
      "Accompagne les personnes pendant la grossesse et après la naissance, notamment en consultation ou à domicile.",
      "Cette sage-femme diplômée travaille principalement hors de l’hôpital. Elle assure des contrôles pendant la grossesse et après la naissance, répond aux questions et oriente vers d’autres services si nécessaire. Les modalités varient selon le service local."
    ],
    "specialist_midwife": [
      "Sage-femme spécialisée",
      "Sage-femme diplômée qui travaille dans un domaine particulier des soins de maternité ou d’un service spécialisé.",
      "Certaines accompagnent des personnes ayant un diabète, une épilepsie ou d’autres problèmes de santé, ou interviennent en médecine maternelle et surveillance fœtale. D’autres travaillent dans la recherche, le numérique en maternité ou la protection des personnes vulnérables. Leurs missions varient et toutes ne donnent pas de consultations. La participation à la recherche est volontaire."
    ],
    "labour_ward_coordinator": [
      "Sage-femme coordinatrice de salle de naissance",
      "Sage-femme expérimentée qui aide à coordonner les soins dans le service d’accouchement.",
      "Elle organise les soins, soutient l’équipe de sages-femmes et facilite l’intervention de professionnels plus expérimentés si nécessaire. Elle travaille avec toute l’équipe de maternité; la sage-femme qui vous accompagne continue à assurer vos soins."
    ]
  },
  "es": {
    "community_midwife": [
      "Matrona comunitaria",
      "Te acompaña durante el embarazo y después del parto, a menudo en consultas comunitarias o visitas domiciliarias.",
      "Es una matrona titulada que trabaja principalmente fuera del hospital. Puede realizar controles del embarazo y del posparto, resolver dudas y organizar apoyo adicional. La atención disponible depende del servicio local."
    ],
    "specialist_midwife": [
      "Matrona especialista",
      "Matrona titulada que se centra en un área concreta de la atención materna o de un servicio especializado.",
      "Algunas apoyan a personas con diabetes, epilepsia u otros problemas de salud, o trabajan en medicina materna y monitorización fetal. Otras trabajan en investigación, servicios digitales de maternidad o protección de personas vulnerables. Sus funciones varían; no todas realizan consultas. Participar en investigaciones es voluntario."
    ],
    "labour_ward_coordinator": [
      "Matrona coordinadora de paritorio",
      "Matrona con experiencia que ayuda a coordinar la atención en el paritorio.",
      "Organiza la atención, apoya al equipo de matronas y facilita la ayuda de profesionales con más experiencia cuando se necesita. Trabaja con el resto del equipo; tu matrona habitual sigue participando en tus cuidados."
    ]
  },
  "ar": {
    "community_midwife": [
      "القابلة المجتمعية",
      "تقدم الدعم خلال الحمل وبعد الولادة، غالباً في العيادات المجتمعية أو من خلال الزيارات المنزلية.",
      "هي قابلة مسجلة تعمل غالباً خارج المستشفى. قد تجري فحوص الحمل وما بعد الولادة، وتجيب عن الأسئلة وتساعد في ترتيب دعم إضافي. تختلف الترتيبات حسب خدمة الأمومة المحلية."
    ],
    "specialist_midwife": [
      "القابلة المتخصصة",
      "قابلة مسجلة يتركز عملها على جانب معين من رعاية الأمومة أو على خدمة متخصصة.",
      "تساعد بعض القابلات المتخصصات في الرعاية المتعلقة بالسكري أو الصرع أو غيرهما من الحالات الصحية، أو يعملن في طب الأمومة ومراقبة الجنين. وتعمل أخريات في البحوث أو الأنظمة الرقمية للأمومة أو حماية الأشخاص المعرضين للخطر. تختلف مهامهن، ولا تقدم جميعهن مواعيد سريرية. المشاركة في البحوث اختيارية."
    ],
    "labour_ward_coordinator": [
      "القابلة المنسقة لجناح الولادة",
      "قابلة ذات خبرة تساعد في تنسيق الرعاية داخل جناح الولادة.",
      "تساعد في تنظيم الرعاية ودعم فريق القابلات وترتيب مشاركة أفراد أقدم من الفريق عند الحاجة. وهي تعمل مع فريق الأمومة الأوسع، وتظل القابلة التي تعتني بك مشاركة في رعايتك."
    ]
  },
  "pt": {
    "community_midwife": [
      "Parteira comunitária",
      "Acompanha a pessoa durante a gravidez e após o nascimento, muitas vezes em consultas comunitárias ou visitas domiciliárias.",
      "É uma parteira habilitada que trabalha sobretudo fora do hospital. Pode realizar avaliações durante a gravidez e após o parto, esclarecer dúvidas e ajudar a organizar apoio adicional. Os serviços variam consoante a unidade local."
    ],
    "specialist_midwife": [
      "Parteira especialista",
      "Parteira habilitada que se dedica a uma área específica dos cuidados de maternidade ou a um serviço especializado.",
      "Algumas apoiam pessoas com diabetes, epilepsia ou outras condições de saúde, ou trabalham em medicina materna e monitorização fetal. Outras trabalham em investigação, sistemas digitais de maternidade ou proteção de pessoas vulneráveis. As funções variam e nem todas realizam consultas. A participação na investigação é voluntária."
    ],
    "labour_ward_coordinator": [
      "Parteira coordenadora da sala de partos",
      "Parteira experiente que ajuda a coordenar os cuidados na unidade de partos.",
      "Organiza os cuidados, apoia a equipa de parteiras e ajuda a obter apoio de profissionais mais experientes quando necessário. Trabalha com toda a equipa de maternidade; a parteira responsável continua envolvida nos seus cuidados."
    ]
  },
  "it": {
    "community_midwife": [
      "Ostetrica territoriale",
      "Ti sostiene durante la gravidanza e dopo il parto, spesso in ambulatori territoriali o tramite visite a domicilio.",
      "È un’ostetrica abilitata che lavora principalmente fuori dall’ospedale. Può effettuare controlli durante la gravidanza e dopo il parto, rispondere alle domande e aiutare a organizzare ulteriore assistenza. Le modalità dipendono dal servizio locale."
    ],
    "specialist_midwife": [
      "Ostetrica specializzata",
      "Ostetrica abilitata che si occupa di uno specifico ambito dell’assistenza alla maternità o di un servizio specialistico.",
      "Alcune seguono persone con diabete, epilessia o altre condizioni di salute, oppure lavorano nella medicina materna e nel monitoraggio fetale. Altre si occupano di ricerca, sistemi digitali per la maternità o tutela delle persone vulnerabili. I compiti variano e non tutte effettuano visite cliniche. Partecipare alla ricerca è volontario."
    ],
    "labour_ward_coordinator": [
      "Ostetrica coordinatrice della sala parto",
      "Ostetrica esperta che aiuta a coordinare l’assistenza in sala parto.",
      "Organizza l’assistenza, sostiene il gruppo di ostetriche e facilita il coinvolgimento di professionisti più esperti quando serve. Collabora con l’intera équipe; l’ostetrica che ti assiste continua a prendersi cura di te."
    ]
  },
  "pl": {
    "community_midwife": [
      "Położna środowiskowa",
      "Wspiera Cię w ciąży i po porodzie, często w poradni lub podczas wizyt domowych.",
      "To położna posiadająca uprawnienia zawodowe, pracująca głównie poza szpitalem. Może wykonywać kontrole w ciąży i po porodzie, odpowiadać na pytania i organizować dodatkową pomoc. Zakres opieki zależy od lokalnej placówki."
    ],
    "specialist_midwife": [
      "Położna specjalistyczna",
      "Położna zajmująca się określonym obszarem opieki okołoporodowej lub specjalistyczną usługą.",
      "Niektóre wspierają osoby z cukrzycą, padaczką lub innymi chorobami albo pracują w medycynie matczyno-płodowej i monitorowaniu płodu. Inne zajmują się badaniami naukowymi, systemami cyfrowymi w położnictwie lub ochroną osób narażonych na krzywdę. Obowiązki są różne i nie każda prowadzi wizyty. Udział w badaniach jest dobrowolny."
    ],
    "labour_ward_coordinator": [
      "Położna koordynująca salę porodową",
      "Doświadczona położna pomagająca koordynować opiekę na oddziale porodowym.",
      "Organizuje opiekę, wspiera zespół położnych i pomaga uzyskać wsparcie bardziej doświadczonych specjalistów, gdy jest potrzebne. Współpracuje z całym zespołem; położna opiekująca się Tobą nadal uczestniczy w Twojej opiece."
    ]
  },
  "ro": {
    "community_midwife": [
      "Moașă comunitară",
      "Oferă sprijin în timpul sarcinii și după naștere, adesea în cabinete comunitare sau prin vizite la domiciliu.",
      "Este o moașă calificată care lucrează în principal în afara spitalului. Poate efectua controale în sarcină și după naștere, răspunde la întrebări și ajută la organizarea unui sprijin suplimentar. Serviciile diferă de la o unitate la alta."
    ],
    "specialist_midwife": [
      "Moașă specializată",
      "Moașă calificată care se concentrează pe un anumit domeniu al îngrijirii maternității sau pe un serviciu specializat.",
      "Unele sprijină persoane cu diabet, epilepsie sau alte afecțiuni ori lucrează în medicina maternă și monitorizarea fătului. Altele lucrează în cercetare, sisteme digitale de maternitate sau protecția persoanelor vulnerabile. Responsabilitățile diferă; nu toate oferă consultații. Participarea la cercetare este voluntară."
    ],
    "labour_ward_coordinator": [
      "Moașă coordonatoare a sălii de nașteri",
      "Moașă cu experiență care ajută la coordonarea îngrijirii în sala de nașteri.",
      "Organizează îngrijirea, sprijină echipa de moașe și ajută la obținerea sprijinului unor colegi cu mai multă experiență când este nevoie. Colaborează cu echipa de maternitate; moașa care vă îngrijește rămâne implicată."
    ]
  },
  "tr": {
    "community_midwife": [
      "Toplum ebesi",
      "Gebelikte ve doğumdan sonra, genellikle toplum sağlığı kliniklerinde veya ev ziyaretlerinde destek sağlar.",
      "Çoğunlukla hastane dışında çalışan kayıtlı bir ebedir. Gebelik ve doğum sonrası kontrolleri yapabilir, sorularınızı yanıtlayabilir ve ek destek ayarlamanıza yardımcı olabilir. Hizmetin ayrıntıları yerel birime göre değişir."
    ],
    "specialist_midwife": [
      "Uzmanlık alanı olan ebe",
      "Doğum hizmetlerinin belirli bir alanında veya özel bir hizmette görev yapan kayıtlı ebedir.",
      "Bazıları diyabet, epilepsi veya diğer sağlık sorunlarında destek sağlar ya da anne sağlığı ve fetüs izlemi alanlarında çalışır. Diğerleri araştırma, dijital doğum hizmetleri veya korunmaya ihtiyaç duyan kişilerin güvenliği alanlarında görev yapar. Görevler değişir; hepsi hasta muayenesi yapmaz. Araştırmaya katılım gönüllüdür."
    ],
    "labour_ward_coordinator": [
      "Doğumhane koordinatör ebesi",
      "Doğumhanedeki bakımın koordinasyonuna yardımcı olan deneyimli ebedir.",
      "Bakımı düzenler, ebelere destek olur ve gerektiğinde kıdemli ekip üyelerinin katılımını sağlar. Geniş doğum ekibiyle birlikte çalışır; sizinle ilgilenen ebe bakımınıza devam eder."
    ]
  },
  "fa": {
    "community_midwife": [
      "مامای جامعه‌نگر",
      "در دوران بارداری و پس از زایمان، اغلب در درمانگاه‌های محلی یا با مراجعه به منزل از شما حمایت می‌کند.",
      "مامای دارای مجوزی است که بیشتر خارج از بیمارستان کار می‌کند. ممکن است بررسی‌های بارداری و پس از زایمان را انجام دهد، به پرسش‌ها پاسخ دهد و برای دریافت حمایت بیشتر کمک کند. خدمات بسته به مرکز محلی متفاوت است."
    ],
    "specialist_midwife": [
      "مامای متخصص در یک حوزه",
      "مامای دارای مجوزی که بر بخشی مشخص از مراقبت‌های بارداری و زایمان یا خدمات تخصصی تمرکز دارد.",
      "برخی در مراقبت از افراد مبتلا به دیابت، صرع یا بیماری‌های دیگر یا در طب مادر و پایش جنین فعالیت می‌کنند. برخی دیگر در پژوهش، سامانه‌های دیجیتال زایمان یا حفاظت از افراد آسیب‌پذیر کار می‌کنند. وظایف متفاوت است و همه آن‌ها ویزیت بالینی ندارند. شرکت در پژوهش اختیاری است."
    ],
    "labour_ward_coordinator": [
      "مامای هماهنگ‌کننده بخش زایمان",
      "مامای باتجربه‌ای که به هماهنگی مراقبت‌ها در بخش زایمان کمک می‌کند.",
      "مراقبت‌ها را سازمان‌دهی می‌کند، از تیم مامایی پشتیبانی می‌کند و در صورت نیاز برای حضور همکاران ارشد کمک می‌گیرد. با کل تیم زایمان همکاری می‌کند و مامایی که از شما مراقبت می‌کند همچنان درگیر مراقبت شماست."
    ]
  },
  "ur": {
    "community_midwife": [
      "کمیونٹی مڈوائف",
      "حمل کے دوران اور بچے کی پیدائش کے بعد مدد فراہم کرتی ہیں، اکثر مقامی کلینک یا گھر کے دوروں کے ذریعے۔",
      "یہ رجسٹرڈ مڈوائف ہوتی ہیں جو زیادہ تر ہسپتال سے باہر کام کرتی ہیں۔ حمل اور پیدائش کے بعد معائنے کر سکتی ہیں، سوالات کا جواب دیتی ہیں اور مزید مدد حاصل کرنے میں تعاون کرتی ہیں۔ مقامی خدمات کے انتظامات مختلف ہو سکتے ہیں۔"
    ],
    "specialist_midwife": [
      "ماہر شعبے کی مڈوائف",
      "رجسٹرڈ مڈوائف جو زچگی کی دیکھ بھال کے کسی خاص شعبے یا خصوصی سروس میں کام کرتی ہیں۔",
      "بعض مڈوائف ذیابیطس، مرگی یا دیگر بیماریوں میں مدد دیتی ہیں یا ماں کی طب اور بچے کی نگرانی میں کام کرتی ہیں۔ دوسری تحقیق، ڈیجیٹل زچگی کی خدمات یا کمزور افراد کے تحفظ سے متعلق کام کرتی ہیں۔ ان کی ذمہ داریاں مختلف ہوتی ہیں اور سب مریضوں کو براہِ راست نہیں دیکھتیں۔ تحقیق میں حصہ لینا اختیاری ہے۔"
    ],
    "labour_ward_coordinator": [
      "لیبر وارڈ کی رابطہ کار مڈوائف",
      "تجربہ کار مڈوائف جو لیبر وارڈ میں دیکھ بھال کی ہم آہنگی میں مدد کرتی ہیں۔",
      "دیکھ بھال منظم کرتی ہیں، مڈوائف ٹیم کو مدد دیتی ہیں اور ضرورت پڑنے پر سینئر عملے کو شامل کرتی ہیں۔ وہ پوری زچگی ٹیم کے ساتھ کام کرتی ہیں؛ آپ کی دیکھ بھال کرنے والی مڈوائف بھی شامل رہتی ہیں۔"
    ]
  },
  "bn": {
    "community_midwife": [
      "কমিউনিটি মিডওয়াইফ",
      "গর্ভাবস্থায় ও সন্তান জন্মের পরে সহায়তা করেন, সাধারণত কমিউনিটি ক্লিনিক বা বাড়িতে যাওয়ার মাধ্যমে।",
      "তিনি একজন নিবন্ধিত মিডওয়াইফ, যিনি মূলত হাসপাতালের বাইরে কাজ করেন। গর্ভকালীন ও প্রসব-পরবর্তী পরীক্ষা করতে, প্রশ্নের উত্তর দিতে এবং অতিরিক্ত সহায়তার ব্যবস্থা করতে পারেন। স্থানীয় সেবার ধরন আলাদা হতে পারে।"
    ],
    "specialist_midwife": [
      "বিশেষায়িত মিডওয়াইফ",
      "নিবন্ধিত মিডওয়াইফ, যিনি মাতৃত্বকালীন পরিচর্যার নির্দিষ্ট একটি ক্ষেত্র বা বিশেষ সেবায় কাজ করেন।",
      "কেউ ডায়াবেটিস, মৃগীরোগ বা অন্যান্য স্বাস্থ্যসমস্যায় সহায়তা করেন; কেউ মাতৃস্বাস্থ্য ও ভ্রূণের পর্যবেক্ষণে কাজ করেন। অন্যরা গবেষণা, ডিজিটাল মাতৃত্বসেবা বা ঝুঁকিপূর্ণ ব্যক্তিদের সুরক্ষায় কাজ করেন। দায়িত্ব ভিন্ন হতে পারে এবং সবাই সরাসরি রোগী দেখেন না। গবেষণায় অংশ নেওয়া স্বেচ্ছামূলক।"
    ],
    "labour_ward_coordinator": [
      "প্রসব ওয়ার্ড সমন্বয়কারী মিডওয়াইফ",
      "অভিজ্ঞ মিডওয়াইফ, যিনি প্রসব ওয়ার্ডের সেবা সমন্বয় করতে সাহায্য করেন।",
      "তিনি সেবা সংগঠিত করেন, মিডওয়াইফদের সহায়তা করেন এবং প্রয়োজনে জ্যেষ্ঠ কর্মীদের যুক্ত করতে সাহায্য করেন। তিনি পুরো মাতৃত্বসেবা দলের সঙ্গে কাজ করেন; আপনার নিয়মিত মিডওয়াইফও আপনার পরিচর্যায় যুক্ত থাকেন।"
    ]
  },
  "gu": {
    "community_midwife": [
      "સમુદાય મિડવાઇફ",
      "ગર્ભાવસ્થા દરમિયાન અને બાળકના જન્મ પછી, ઘણી વાર સ્થાનિક ક્લિનિક અથવા ઘરે મુલાકાત દ્વારા મદદ કરે છે.",
      "આ નોંધાયેલ મિડવાઇફ મુખ્યત્વે હોસ્પિટલની બહાર કામ કરે છે. ગર્ભાવસ્થા અને પ્રસૂતિ પછી તપાસ કરી શકે, પ્રશ્નોના જવાબ આપી શકે અને વધુ મદદ ગોઠવવામાં સહાય કરી શકે છે. સ્થાનિક સેવાઓ અલગ હોઈ શકે છે."
    ],
    "specialist_midwife": [
      "વિશેષ ક્ષેત્રની મિડવાઇફ",
      "માતૃત્વ સંભાળના કોઈ ખાસ ક્ષેત્ર અથવા વિશેષ સેવામાં કામ કરતી નોંધાયેલ મિડવાઇફ.",
      "કેટલીક ડાયાબિટીસ, વાઈ અથવા અન્ય આરોગ્ય સમસ્યાઓમાં મદદ કરે છે અથવા માતાના સ્વાસ્થ્ય અને ગર્ભના નિરીક્ષણમાં કામ કરે છે. અન્ય સંશોધન, ડિજિટલ માતૃત્વ સેવાઓ અથવા જોખમમાં રહેલા લોકોના રક્ષણમાં કામ કરે છે. તેમની જવાબદારીઓ અલગ હોય છે અને દરેક દર્દીઓને સીધી મુલાકાત આપતી નથી. સંશોધનમાં ભાગ લેવો સ્વૈચ્છિક છે."
    ],
    "labour_ward_coordinator": [
      "પ્રસૂતિ વોર્ડ સંકલન મિડવાઇફ",
      "અનુભવી મિડવાઇફ જે પ્રસૂતિ વોર્ડમાં સંભાળનું સંકલન કરવામાં મદદ કરે છે.",
      "તે સંભાળ ગોઠવે છે, મિડવાઇફ ટીમને ટેકો આપે છે અને જરૂર પડે ત્યારે વરિષ્ઠ કર્મચારીઓની મદદ મેળવે છે. તે સમગ્ર માતૃત્વ ટીમ સાથે કામ કરે છે; તમારી સંભાળ રાખતી મિડવાઇફ જોડાયેલી રહે છે."
    ]
  },
  "pa": {
    "community_midwife": [
      "ਕਮਿਊਨਿਟੀ ਮਿਡਵਾਈਫ",
      "ਗਰਭ ਅਵਸਥਾ ਦੌਰਾਨ ਅਤੇ ਬੱਚੇ ਦੇ ਜਨਮ ਤੋਂ ਬਾਅਦ ਮਦਦ ਕਰਦੀ ਹੈ, ਅਕਸਰ ਸਥਾਨਕ ਕਲੀਨਿਕਾਂ ਜਾਂ ਘਰ ਦੇ ਦੌਰਿਆਂ ਰਾਹੀਂ।",
      "ਇਹ ਇੱਕ ਰਜਿਸਟਰਡ ਮਿਡਵਾਈਫ ਹੁੰਦੀ ਹੈ ਜੋ ਮੁੱਖ ਤੌਰ ਤੇ ਹਸਪਤਾਲ ਤੋਂ ਬਾਹਰ ਕੰਮ ਕਰਦੀ ਹੈ। ਗਰਭ ਅਵਸਥਾ ਅਤੇ ਜਨਮ ਤੋਂ ਬਾਅਦ ਜਾਂਚਾਂ, ਸਵਾਲਾਂ ਦੇ ਜਵਾਬ ਅਤੇ ਵਾਧੂ ਮਦਦ ਦਾ ਪ੍ਰਬੰਧ ਕਰਨ ਵਿੱਚ ਸਹਾਇਤਾ ਕਰ ਸਕਦੀ ਹੈ। ਸਥਾਨਕ ਸੇਵਾਵਾਂ ਵੱਖਰੀਆਂ ਹੋ ਸਕਦੀਆਂ ਹਨ।"
    ],
    "specialist_midwife": [
      "ਖ਼ਾਸ ਖੇਤਰ ਦੀ ਮਿਡਵਾਈਫ",
      "ਰਜਿਸਟਰਡ ਮਿਡਵਾਈਫ ਜੋ ਮਾਤਰਤਵ ਸੰਭਾਲ ਦੇ ਕਿਸੇ ਖ਼ਾਸ ਖੇਤਰ ਜਾਂ ਵਿਸ਼ੇਸ਼ ਸੇਵਾ ਵਿੱਚ ਕੰਮ ਕਰਦੀ ਹੈ।",
      "ਕੁਝ ਮਿਡਵਾਈਫਾਂ ਸ਼ੂਗਰ, ਮਿਰਗੀ ਜਾਂ ਹੋਰ ਸਿਹਤ ਸਮੱਸਿਆਵਾਂ ਵਿੱਚ ਮਦਦ ਕਰਦੀਆਂ ਹਨ ਜਾਂ ਮਾਂ ਦੀ ਸਿਹਤ ਅਤੇ ਗਰਭ ਵਿੱਚ ਬੱਚੇ ਦੀ ਨਿਗਰਾਨੀ ਨਾਲ ਸੰਬੰਧਤ ਕੰਮ ਕਰਦੀਆਂ ਹਨ। ਹੋਰ ਖੋਜ, ਡਿਜ਼ਿਟਲ ਮਾਤਰਤਵ ਸੇਵਾਵਾਂ ਜਾਂ ਕਮਜ਼ੋਰ ਲੋਕਾਂ ਦੀ ਸੁਰੱਖਿਆ ਨਾਲ ਜੁੜੀਆਂ ਹੁੰਦੀਆਂ ਹਨ। ਜ਼ਿੰਮੇਵਾਰੀਆਂ ਵੱਖਰੀਆਂ ਹੁੰਦੀਆਂ ਹਨ ਅਤੇ ਸਭ ਮਰੀਜ਼ਾਂ ਨੂੰ ਸਿੱਧੇ ਨਹੀਂ ਮਿਲਦੀਆਂ। ਖੋਜ ਵਿੱਚ ਹਿੱਸਾ ਲੈਣਾ ਆਪਣੀ ਮਰਜ਼ੀ ਨਾਲ ਹੁੰਦਾ ਹੈ।"
    ],
    "labour_ward_coordinator": [
      "ਲੇਬਰ ਵਾਰਡ ਕੋਆਰਡੀਨੇਟਰ ਮਿਡਵਾਈਫ",
      "ਤਜਰਬੇਕਾਰ ਮਿਡਵਾਈਫ ਜੋ ਲੇਬਰ ਵਾਰਡ ਵਿੱਚ ਸੰਭਾਲ ਦਾ ਤਾਲਮੇਲ ਕਰਦੀ ਹੈ।",
      "ਉਹ ਸੰਭਾਲ ਦਾ ਪ੍ਰਬੰਧ ਕਰਦੀ ਹੈ, ਮਿਡਵਾਈਫ ਟੀਮ ਦਾ ਸਹਿਯੋਗ ਕਰਦੀ ਹੈ ਅਤੇ ਲੋੜ ਪੈਣ ਤੇ ਸੀਨੀਅਰ ਕਰਮਚਾਰੀਆਂ ਦੀ ਮਦਦ ਲੈਂਦੀ ਹੈ। ਉਹ ਪੂਰੀ ਮਾਤਰਤਵ ਟੀਮ ਨਾਲ ਕੰਮ ਕਰਦੀ ਹੈ; ਤੁਹਾਡੀ ਮਿਡਵਾਈਫ ਵੀ ਤੁਹਾਡੀ ਸੰਭਾਲ ਵਿੱਚ ਸ਼ਾਮਲ ਰਹਿੰਦੀ ਹੈ।"
    ]
  },
  "so": {
    "community_midwife": [
      "Umuliso bulshada ka shaqaysa",
      "Waxay ku taageertaa xilliga uurka iyo dhalmada ka dib, badanaa rugaha bulshada ama booqashooyinka guriga.",
      "Waa umuliso diiwaangashan oo inta badan ka shaqaysa meel ka baxsan isbitaalka. Waxay samayn kartaa baaritaanno uurka iyo dhalmada ka dib, su’aalaha ka jawaabi kartaa, waxayna kaa caawin kartaa helitaanka taageero dheeraad ah. Adeegyada deegaanka way kala duwan yihiin."
    ],
    "specialist_midwife": [
      "Umuliso ku takhasustay qayb gaar ah",
      "Umuliso diiwaangashan oo ka shaqaysa dhinac gaar ah oo daryeelka hooyada ama adeeg takhasus leh.",
      "Qaar waxay taageeraan dadka qaba sonkorow, suuxdin ama xaalado kale, ama waxay ka shaqeeyaan caafimaadka hooyada iyo la socodka ilmaha uurka ku jira. Kuwo kale waxay ka shaqeeyaan cilmi-baaris, nidaamyada dijitaalka ah ee umulinta ama ilaalinta dadka nugul. Shaqooyinkoodu way kala duwan yihiin, dhammaantoodna ma bixiyaan ballamo bukaan. Ka qaybgalka cilmi-baaristu waa ikhtiyaari."
    ],
    "labour_ward_coordinator": [
      "Umulisada isku dubbaridda qaybta dhalmada",
      "Umuliso khibrad leh oo gacan ka geysata isku dubbaridka daryeelka qaybta dhalmada.",
      "Waxay abaabushaa daryeelka, taageertaa kooxda umulisooyinka, waxayna gacan ka geysataa in shaqaale sare la helo marka loo baahdo. Waxay la shaqaysaa kooxda dhalmada oo dhan; umulisada ku daryeeshaana way sii qaybqaadataa."
    ]
  },
  "tl": {
    "community_midwife": [
      "Midwife sa Komunidad",
      "Tumutulong sa iyo habang buntis at pagkatapos manganak, kadalasan sa mga klinika sa komunidad o sa pagbisita sa bahay.",
      "Isa siyang rehistradong midwife na karaniwang nagtatrabaho sa labas ng ospital. Maaari siyang magsagawa ng mga pagsusuri habang buntis at pagkatapos manganak, sumagot sa mga tanong, at tumulong mag-ayos ng dagdag na suporta. Nag-iiba ang mga serbisyo depende sa lugar."
    ],
    "specialist_midwife": [
      "Midwife na Nakatuon sa Espesyal na Larangan",
      "Rehistradong midwife na nakatuon sa isang partikular na bahagi ng pangangalaga sa pagbubuntis o espesyal na serbisyo.",
      "Ang ilan ay tumutulong sa mga may diabetes, epilepsy o ibang kondisyon, o nagtatrabaho sa maternal medicine at pagsubaybay sa sanggol sa sinapupunan. Ang iba naman ay nasa pananaliksik, digital maternity services o pagprotekta sa mga taong nanganganib. Iba-iba ang gawain nila at hindi lahat ay may direktang appointment sa pasyente. Boluntaryo ang pagsali sa pananaliksik."
    ],
    "labour_ward_coordinator": [
      "Midwife na Tagapag-ugnay sa Labour Ward",
      "Bihasang midwife na tumutulong mag-ugnay ng pangangalaga sa labour ward.",
      "Inaayos niya ang pangangalaga, sinusuportahan ang mga midwife at tumutulong humingi ng tulong sa nakatatandang kawani kung kailangan. Kasama siya sa mas malawak na maternity team; patuloy na kasali sa pangangalaga mo ang midwife na nag-aalaga sa iyo."
    ]
  },
  "zh": {
    "community_midwife": [
      "社区助产士",
      "在孕期和分娩后提供支持，通常在社区门诊或通过家访提供服务。",
      "这是主要在医院以外工作的注册助产士。她们可能进行孕期及产后检查、回答问题，并协助安排额外支持。具体服务安排因当地医疗机构而异。"
    ],
    "specialist_midwife": [
      "专科助产士",
      "专注于孕产妇护理某一领域或专门服务的注册助产士。",
      "有些专科助产士为糖尿病、癫痫或其他健康问题提供支持，或从事孕产妇医学与胎儿监测工作。另一些从事研究、数字化孕产服务或弱势人群保护工作。职责因岗位而异，并非所有专科助产士都直接接诊。参与研究完全自愿。"
    ],
    "labour_ward_coordinator": [
      "产房协调助产士",
      "经验丰富的助产士，协助协调产房中的护理工作。",
      "她们组织护理工作、支持助产团队，并在需要时协调资深医护人员参与。她们与整个孕产团队协作，负责照顾您的助产士仍会继续参与您的护理。"
    ]
  }
};
